import React from "react";
import { useNavigate } from "react-router-dom";

import { NavBtnLink, NavBarContainer, NavBtn, NavBarUser } from "./styles";
import { useAuth } from "../../contexts/AuthContext";
//import logo from "./../../images/budgetify_logo.png";
import icon from "./../../images/budgetify_logo.ico";
const Navbar = () => {
  const { logout, currentUser } = useAuth();
  const navigate = useNavigate();

  return (
    <>
      <div>
        {currentUser ? (
          <NavBarUser>
            <NavBtn
              onClick={() => {
                logout().then(() => {
                  navigate("/", { replace: true });
                });
              }}
            >
              Logout
            </NavBtn>
            <i className="bi bi-person-fill"></i>{" "}
            {currentUser.auth.currentUser.email}
          </NavBarUser>
        ) : (
          <NavBarUser>
            <NavBtnLink to="/login">Login</NavBtnLink>
            <NavBtnLink to="/register">Register</NavBtnLink>
          </NavBarUser>
        )}

        <h1 className="site-title">
          <img src={icon} alt="icon" className="icon center" />
          Budgetify
        </h1>
      </div>
      <NavBarContainer>
        {currentUser ? (
          <NavBtnLink to="/dashboard">Dashboard</NavBtnLink>
        ) : (
          <NavBtnLink to="/">Home</NavBtnLink>
        )}
        <NavBtnLink to="/about">About</NavBtnLink>
        {currentUser ? <NavBtnLink to="/budget">Budget</NavBtnLink> : null}

        {currentUser ? (
          <NavBtnLink to="/transactions">Transactions</NavBtnLink>
        ) : null}
        {currentUser ? <NavBtnLink to="/calendar">Calendar</NavBtnLink> : null}
      </NavBarContainer>
    </>
  );
};

export default Navbar;
